import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";

import { mediaItemHoverOpacity } from "theme";

const useStyles = makeStyles((theme: Theme) => {
    const imageContainerBorder = (borderColor: string) => `2px solid ${borderColor}`;

    return createStyles({
        root: {
            cursor: "pointer",
            "&:hover": {
                opacity: mediaItemHoverOpacity,
            },
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {}

export default function ClickableMediaItem(props: IProps) {
    const classes = useStyles();
    const { className, children, ...rest } = props;

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {children}
        </div>
    );
}
